import { buildModelManager } from "../builder.js";
const DefaultVoiceSimSessionSelection = {
  __typename: true,
  id: true,
  accessedFromIPs: true,
  attemptsAllowed: true,
  attemptsUsed: true,
  boundToDevice: true,
  cohortId: true,
  createdAt: true,
  deviceFingerprint: true,
  expiresAt: true,
  firstAccessedAt: true,
  isActive: true,
  lastAccessedAt: true,
  lastAttemptAt: true,
  metadata: true,
  scenarioId: true,
  sharedById: true,
  status: true,
  studentEmail: true,
  studentId: true,
  token: true,
  updatedAt: true
};
const modelApiIdentifier = "voiceSimSession";
const pluralModelApiIdentifier = "voiceSimSessions";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByToken",
    findByField: "token",
    findByVariableName: "token",
    modelApiIdentifier,
    defaultSelection: DefaultVoiceSimSessionSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createVoiceSimSession",
    operationReturnType: "CreateVoiceSimSession",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      voiceSimSession: { required: false, type: "CreateVoiceSimSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "action",
    operationName: "bulkCreateVoiceSimSessions",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateVoiceSimSessionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "action",
    operationName: "updateVoiceSimSession",
    operationReturnType: "UpdateVoiceSimSession",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      voiceSimSession: { required: false, type: "UpdateVoiceSimSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateVoiceSimSessions",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateVoiceSimSessionsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "action",
    operationName: "deleteVoiceSimSession",
    operationReturnType: "DeleteVoiceSimSession",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteVoiceSimSessions",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertVoiceSimSession",
    operationReturnType: "UpsertVoiceSimSession",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      voiceSimSession: { required: false, type: "UpsertVoiceSimSessionInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateVoiceSimSessionResult": { hasReturnType: false },
      "... on UpdateVoiceSimSessionResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertVoiceSimSessions",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertVoiceSimSessionsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultVoiceSimSessionSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "voiceSimSessionGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const VoiceSimSessionManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultVoiceSimSessionSelection,
  operations
);
export {
  DefaultVoiceSimSessionSelection,
  VoiceSimSessionManager
};
//# sourceMappingURL=VoiceSimSession.js.map
